export const NAV = {
    logo: 'nav-logo-link',
    signInBtn: 'nav-signin-btn',
    getStartedBtn: 'nav-get-started-btn',
    logoutBtn: 'nav-logout-btn',
    dashboardLink: 'nav-dashboard-link',
    shiftsLink: 'nav-shifts-link',
    paymentsLink: 'nav-payments-link',
    vaultLink: 'nav-vault-link',
    notifyLink: 'nav-notify-link',
};

export const LANDING = {
    hero: 'landing-hero',
    heroCta: 'landing-hero-cta-btn',
    heroSecondary: 'landing-hero-secondary-btn',
    featureCard: 'landing-feature-card',
};

export const AUTH = {
    tabAgency: 'auth-tab-agency',
    tabCaregiver: 'auth-tab-caregiver',
    modeLogin: 'auth-mode-login',
    modeRegister: 'auth-mode-register',
    emailInput: 'auth-email-input',
    passwordInput: 'auth-password-input',
    fullNameInput: 'auth-fullname-input',
    phoneInput: 'auth-phone-input',
    agencyNameInput: 'auth-agency-name-input',
    einInput: 'auth-ein-input',
    submitBtn: 'auth-submit-btn',
    error: 'auth-error',
};

export const AGENCY = {
    dashboard: 'agency-dashboard',
    onboardStripeBtn: 'agency-onboard-stripe-btn',
    einBadge: 'agency-ein-badge',
    stripeStatusBadge: 'agency-stripe-status-badge',
    createShiftBtn: 'agency-create-shift-btn',
    shiftTitleInput: 'agency-shift-title-input',
    shiftLocationInput: 'agency-shift-location-input',
    shiftStartInput: 'agency-shift-start-input',
    shiftEndInput: 'agency-shift-end-input',
    shiftRateInput: 'agency-shift-rate-input',
    shiftSubmit: 'agency-shift-submit-btn',
};

export const CAREGIVER = {
    dashboard: 'caregiver-dashboard',
    resumeUploadInput: 'caregiver-resume-upload-input',
    resumeUploadBtn: 'caregiver-resume-upload-btn',
    resumeResults: 'caregiver-resume-results',
    connectGoogleBtn: 'caregiver-connect-google-btn',
    googleStatus: 'caregiver-google-status',
    claimShiftBtn: 'caregiver-claim-shift-btn',
    pushCalendarBtn: 'caregiver-push-calendar-btn',
};

export const PAYMENTS = {
    panel: 'payments-panel',
    cadenceSelect: 'payments-cadence-select',
    autoPaySwitch: 'payments-autopay-switch',
    methodSelect: 'payments-method-select',
    saveBtn: 'payments-save-btn',
    saved: 'payments-saved-toast',
};

export const VAULT = {
    root: 'vault-root',
    uploadInput: 'vault-upload-input',
    uploadBtn: 'vault-upload-btn',
    categorySelect: 'vault-category-select',
    row: 'vault-row',
    downloadBtn: 'vault-download-btn',
    deleteBtn: 'vault-delete-btn',
};

export const NOTIFY = {
    root: 'notify-root',
    emailToInput: 'notify-email-to-input',
    emailSubjectInput: 'notify-email-subject-input',
    emailBodyInput: 'notify-email-body-input',
    emailSendBtn: 'notify-email-send-btn',
    smsToInput: 'notify-sms-to-input',
    smsBodyInput: 'notify-sms-body-input',
    smsSendBtn: 'notify-sms-send-btn',
    logs: 'notify-logs',
};

export const HOME = { emergentLink: 'home-emergent-link' };
export const LOGIN = { emailInput: 'login-email-input', passwordInput: 'login-password-input', submitButton: 'login-submit-button' };
export const REGISTER = { nameInput: 'register-name-input', emailInput: 'register-email-input', passwordInput: 'register-password-input', submitButton: 'register-submit-button' };
export const LOGOUT = { button: 'logout-button' };
